/**
 * @generated SignedSource<<11ef44b790cd382923e26f9c7c903117>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeleteConditionInput = {
  clientMutationId?: string | null;
  conditionId: string;
  limitedCartDiscountId: string;
};
export type deleteConditionButton_DeleteConditionMutation$variables = {
  input: DeleteConditionInput;
};
export type deleteConditionButton_DeleteConditionMutation$data = {
  readonly Admin: {
    readonly Billing: {
      readonly deleteCondition: {
        readonly limitedCartDiscount: {
          readonly " $fragmentSpreads": FragmentRefs<"limitedCartDiscountForm_LimitedCartDiscountFragment">;
        };
      } | null;
    };
  };
};
export type deleteConditionButton_DeleteConditionMutation = {
  response: deleteConditionButton_DeleteConditionMutation$data;
  variables: deleteConditionButton_DeleteConditionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteConditionButton_DeleteConditionMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Billing",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "DeleteConditionPayload",
                "kind": "LinkedField",
                "name": "deleteCondition",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LimitedCartDiscount",
                    "kind": "LinkedField",
                    "name": "limitedCartDiscount",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "limitedCartDiscountForm_LimitedCartDiscountFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteConditionButton_DeleteConditionMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Billing",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "DeleteConditionPayload",
                "kind": "LinkedField",
                "name": "deleteCondition",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LimitedCartDiscount",
                    "kind": "LinkedField",
                    "name": "limitedCartDiscount",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isReductible",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "conditions",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "kind",
                            "storageKey": null
                          },
                          (v2/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Product",
                                "kind": "LinkedField",
                                "name": "product",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "amount",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "productId",
                                "storageKey": null
                              }
                            ],
                            "type": "ProductSelectionCondition",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "productSelectionConfig",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "value",
                                "storageKey": null
                              }
                            ],
                            "type": "PercentageProductSelectionConfig",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e0ced5a5a73e667f9a6dd3a448d9bf0c",
    "id": null,
    "metadata": {},
    "name": "deleteConditionButton_DeleteConditionMutation",
    "operationKind": "mutation",
    "text": "mutation deleteConditionButton_DeleteConditionMutation(\n  $input: DeleteConditionInput!\n) {\n  Admin {\n    Billing {\n      deleteCondition(input: $input) {\n        limitedCartDiscount {\n          ...limitedCartDiscountForm_LimitedCartDiscountFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment limitedCartDiscountForm_LimitedCartDiscountFragment on LimitedCartDiscount {\n  id\n  title\n  isReductible\n  conditions {\n    __typename\n    kind\n    ... on ProductSelectionCondition {\n      product {\n        title\n        id\n      }\n      id\n      amount\n      productId\n      ...limitedCartDiscountForm_ProductSelectionConditionFragment\n    }\n    id\n  }\n  productSelectionConfig {\n    __typename\n    ... on PercentageProductSelectionConfig {\n      value\n    }\n  }\n}\n\nfragment limitedCartDiscountForm_ProductSelectionConditionFragment on ProductSelectionCondition {\n  id\n  amount\n  productId\n  product {\n    title\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d28f4c1fc903a525884e6550860973d7";

export default node;
